<div class="container-fluid">
    <div class="container">
        <div class="row justify-content-center mt-custom">
            <div class="col-md-8 req-parent">
                <div class="request-img-parent">
                    <img src="assets/images/contacting.jpeg" alt="request_callback" class="img-fluid">
                </div>
                <div class="contact-dealer-form">
                <span class="login100-form-title">
                    Request a Call Back
                </span>
                <form class="validate-form white-layer" [ngClass]="{'white-layer':callbackLoader}"
                    [formGroup]="callback" (ngSubmit)="callbackEnd()">
                    <p style="font-size: 14px;color:green;font-weight:300;text-align: left;" *ngIf="callbackSuccessMsg">
                        <i class="ti-face-smile" aria-hidden="true"></i>&nbsp;<span
                            [innerHtml]="callbackSuccessMsg"></span>
                    </p>
                    <p style="font-size: 14px;color:#db0c0c;font-weight:300;text-align: left;" *ngIf="callbackErrorMsg">
                        <i class="ti-face-sad" aria-hidden="true"></i>&nbsp;<span [innerHTML]="callbackErrorMsg"></span>
                    </p>
                    <div class="wrap-input100">
                        <input type="text" placeholder="Full Name" required class="form-control" formControlName="name" onkeypress="return /[A-Za-z ]/i.test(event.key)">
                        <span class="error-msg" *ngIf="!callback.get('name').valid && callbackSubmit">
                            <p class="error" >Enter valid name</p>
                        </span>
                    </div>
     
                    <div class="wrap-input100 new234" style="z-index: 1;">
                        <ngx-intl-tel-input
                        [enableAutoCountrySelect]="true"
                        [searchCountryFlag]="false"
                        [selectFirstCountry]="false"
                        [preferredCountries]="['in']"
                        [selectedCountryISO]="CountryISO.India"
                        [maxLength]="15"
                        [phoneValidation]="true"
                        name="phone"                                            
                        formControlName="contact" 
                        [enablePlaceholder]="false"
                        [separateDialCode]="true"
                        class="w-100"
                        ></ngx-intl-tel-input>
                        <span class="error-msg" *ngIf="!callback.get('phone').valid && callbackSubmit">
                            <p class="error">Enter Valid Mobile Number</p>
                        </span>
                    </div>
                    <div class="wrap-input100">
                        <input class="input100" type="text" placeholder="Type your message (Optional)"
                            formControlName="message">
                        <span class="focus-input100"></span>
                        <span class="symbol-input100">
                            <i class="ti-pencil" aria-hidden="true"></i>
                        </span>
                    </div>

                    <div class="container-login100-form-btn">
                        <button class="login100-form-btn" type="submit">Submit
                            <div class="box" *ngIf="callbackLoader">
                                <div class="loader-13"></div>
                            </div>
                        </button>
                    </div>
                </form>
        </div>
    </div>
</div>
<div class="row justify-content-center">
    <div class="contact-detail">
        <h1>Please reach out to <u> <a href="mailto:Support@propira.com ">Support@propira.com</a></u>
            for any
            queries! </h1>
    </div>
</div>
</div>